// 移除過期藥物 component

<template lang="pug">
div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar
      div.row.outdated-row(v-if="stage === 'selectDrug'" style="width: 100%; height: 100%; margin: 0")
        ul.nav.nav-pills.nav-fill.nav-autoix
          li.nav-item
            div.nav-link(:class="{ 'active': tabStage === 'expired' }" @click="tabStage = 'expired'") 過期藥物
          li.nav-item
            div.nav-link(:class="{ 'active': tabStage === 'generallyExpired' }" @click="tabStage = 'generallyExpired'") 即期藥物
        div.col-12(v-if="tabStage === 'expired'")
          div.drug-search-list.small-drug-list
            div.with-child-centered(v-if="drugInDeviceList.length === 0") 
              h5 無過期藥物
            div(v-for="drug, num in drugInDeviceList"
              v-else
              @click="selectDrug(num)"
              :class="{ 'btn': true, 'drug-button': true, 'drug-selected': drug.selected }")
              div.drug-head
                div.drug-head--content
                  span(v-if="drug.medication.CGMH_number !== null") [ {{drug.medication.CGMH_number }} - 
                    span {{ drug.medication.code }} ]
                  p {{ drug.medication.generic_name }}
              div.drug-item
                div.info-col#position
                  div.info-col-head
                    span 位置(藥櫃-層-列-行)
                  div.info-col-content
                    p {{ drug.device.net.open_times }} - {{ drug.device.net.row_id }} - {{ drug.device.pos_row }} - {{ drug.device.relative_col }}
                div.info-col#max-amount
                  div.info-col-head
                    span 庫存量(最大量)
                  div.info-col-content
                    p {{ drug.stock }}({{drug.max_stock}})
                div.info-col#patch
                  div.info-col-head
                    span 批號
                  div.info-col-content
                    p(v-if="drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null") 未設定
                    p(v-else) {{ drug.patch_number }}
                div.info-col#expired-date
                  div.info-col-head
                    span 有效期限
                  div.info-col-content
                    p(style="color:red") {{ drug.expired_date }}
        div.col-12(v-if="tabStage === 'generallyExpired'")
          div.drug-search-list.small-drug-list
            div.with-child-centered(v-if="graduallyExpireDrug.length === 0") 
              h5 無即期藥物
            div(v-for="drug, num in graduallyExpireDrug"
              v-else
              :class="{ 'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'unselectable-button': true }")
              div.drug-head
                div.drug-head--content
                  span(v-if="drug.medication.CGMH_number !== null") [ {{drug.medication.CGMH_number }} - 
                    span {{ drug.medication.code }} ]
                  p {{ drug.medication.generic_name }}
              div.drug-item
                div.info-col#position
                  div.info-col-head
                    span 位置(藥櫃-層-列-行)
                  div.info-col-content
                    p {{ drug.device.net.open_times }} - {{ drug.device.net.row_id }} - {{ drug.device.pos_row }} - {{ drug.device.relative_col }}
                div.info-col#max-amount
                  div.info-col-head
                    span 庫存量(最大量)
                  div.info-col-content
                    p {{ drug.stock }}({{drug.max_stock}})
                div.info-col#patch
                  div.info-col-head
                    span 批號
                  div.info-col-content
                    p(v-if="drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null") 未設定
                    p(v-else) {{ drug.patch_number }}
                div.info-col#expired-date
                  div.info-col-head
                    span 有效期限
                  div.info-col-content
                    p {{ drug.expired_date }}
    
        
      
      MultiFlow(
        v-if="stage === 'setFlowData'"
        :multiProgress="multiProgress"
        :confirmProgress="confirmProgress"
        v-on:setAllConfirmData="getAllConfirmData")
      Loader(v-if="stage === 'finish'")

  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="取消選擇" slot="button-8" @click.native="unCheckAll" v-if="stage !== 'setFlowData'")
    action-button(title="全部選擇" slot="button-7" @click.native="checkAll" v-if="stage !== 'setFlowData'")
    action-button(title="開始移除" slot="button-9" @click.native="startFlow" v-if="stage !== 'setFlowData'")
  
  
</template>


<script>
import axios from 'axios';
import progressBar from './flowComp/ProgressBar';
import MultiFlow from './RemoveOutdatedDrugFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';

export default {
  name: 'RemoveOutdatedDrug',
  extends: AppBase,
  components: {
    progressBar,
    MultiFlow,
    Loader,
    BottomButtons,
  },
  data() {
    return {
      tabStage: 'expired',
      graduallyExpireDrug: [],
    };
  },
  created() {
    this.stage = 'selectDrug';
    this.$store.commit('SET_DRUG_IN_DEVICE_LIST', this.expiredDrug);
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted() {
    this.getGraduallyExpireDrug();
    this.$store.commit('SET_PROGRESS', this.progress);
  },
  computed: {
    expiredDrug() {
      return this.$store.state.drugInDevice.expiredDrugInDevice;
    },
    drugInDeviceList() {
      return this.$store.getters.drugInDeviceList;
    },
  },
  methods: {
    setupProgress() {
      const p = [];
      p.push({ en: 'selectDrug', zh: '選擇過期藥物' });
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行移除' });
      return p;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const p = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push('confirmAmount');
      }
      p.push('wait');
      p.push('action');
      p.push('finish');
      p.push('setMinStock');
      return p;
    },
    checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_OUTDATE' });
    },
    selectDrug(num) {
      this.$store.dispatch('selectDrugInDevice', { num });
    },
    getGraduallyExpireDrug() {
      return this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          expired: 'gradually_expired',
          days: this.$store.getters.currentSystem.settings.alert_outdated_day,
        },
      })
      .then((res) => {
        this.graduallyExpireDrug = res.data.results;
      });
    },
    startFlow() {
      if (Object.keys(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    async getAllConfirmData() {
      this.$store.dispatch('resetAll');
      await this.$store.dispatch('getDrugInDevices');
      this.$store.commit('SET_DRUG_IN_DEVICE_LIST', this.expiredDrug);
      this.stage = 'selectDrug';
    },
  },
};
</script>


<style lang="sass">
.outdated-title
  padding-top: 10px
  text-align: center

.small-drug-list
  height: 100%
  padding-left: 10px

.unselectable-button
  box-shadow: none;
  border-style: unset

.nav-autoix
  width: 100%
  // box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
  // border-bottom: 1px solid rgba(0,0,0,0.2)
  .active
    background-color: steelblue !important
  .nav-link
    background-color: aliceblue
    border-radius: 0  

.outdated-row
  .col-12
    padding: 0
    height: calc(100% - 42px)

</style>



// WEBPACK FOOTER //
// RemoveOutdatedDrug.vue?4bd03878